import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";
import ExportButton from "../2/Controls/ExportButton";
import { exportFile } from "../../actions/DataExporter";
import ImportLog from "../ImportLog";
import ImportData from "../ImportData";
import Button from "../2/Controls/Button";
import Expense from "./Expense";

class ExpenseList extends Component {

  constructor(props) {

    super(props);

    this.state = {

      list: [],
      totalCount: 0,
      loading: false,

      page: 1,
      pageSize: 25,

      searchParam: "",

      filter: {
        party: "",
        fromDate: "",
        toDate: "",
        expenseCategory: "",
        expenseNo: "",
        referenceNo: "",
        status: ""
      },

      showFilter: false,
      showOption: false,
      showDelete: false,
      showAddExpense: false,

      selectedRow: null,
      cancellationReason: "",
      cancellationReasonError: "",

      isFilterActive: false,

      listPageSettings: {

        Title: "Expenses",

        Search: {
          showSearch: true,
          placeholder: "Search by party name",
          onSearch: this.onSearch,
          onRefresh: this.onRefreshClick,
          onFilterClick: () => this.setState({ showFilter: true }),
          isFilterActive: false
        },

        HeaderButtons: [
          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          },
          {
            ButtonType: "ImageButton",
            Type: "option",
            Text: "Options",
            Icon: "option",
            Action: "options"
          }
        ],

        Columns: [
          {
            Name: "Expense No",
            Type: "multiple",
            Columns: [
              { Column: "ExpenseNo" },
              { Column: "CancellationReason", Type: "badge", CSS: "red" },
              { Column: "Status", Type: "badge", CSS: "green",        condition: (row) =>
    !row.hasOwnProperty("CancellationReason") ||
    !row.CancellationReason ||
    row.CancellationReason.trim() === ""}
              
            ]
          },
          {
            Name: "Expense Date",
            Type: "field",
            Columns: [{ Column: "ExpenseDate", Type: "date" }]
          },
          {
            Name: "Party",
            Type: "concatenate",
            Columns: [
              { Column: "Party.PartyFirstName" },
              { Column: "Party.PartyLastName" }
            ]
          },
          {
            Name: "Expense Category",
            Type: "field",
            Columns: [{ Column: "ExpenseCategory" }]
          },
          {
            Name: "Reference Number",
            Type: "field",
            Columns: [{ Column: "RefNo" }]
          },
          {
            Name: "Notes",
            Type: "field",
            Columns: [{ Column: "Note" }]
          },
          {
            Name: "Payment Mode",
            Type: "multiple",
            Columns: [
              { Column: "PaymentType" },
              { Column: "CashRegister" },
            ]
          },
          {
            Name: "Payment Remarks",
            Type: "field",
            Columns: [{ Column: "PaymentRemark" }]
          },
          {
            Name: "Amount",
            Type: "field",
            Columns: [{ Column: "Amount", Type: "number" }]
          },
          {
            Name: "Expense No",
            ShowInMobile: true,
            Type: "multiple",
            Columns: [
              { Column: "ExpenseNo" },
              { Column: "CancellationReason", Type: "badge", CSS: "red" },
              { Column: "StatusDisplay", Type: "badge", CSS: "green" },
              { Column: "Party.PartyFirstName" },
              { Column: "Party.PartyLastName" },
              { Column: "ExpenseCategory" }
            ]
          }
        ],

        RowButtons: [
          {
            ButtonType: "ImageButton",
            Type: "edit",
            Text: "Edit",
            Icon: "edit",
               condition: (row) => row.Status !== "Cancelled"
          },
          {
            ButtonType: "ImageButton",
            Type: "delete",
            Text: "Delete",
            Icon: "delete",
             condition: (row) => row.Status !== "Cancelled"
          }
        ]

      }

    };

  }

  componentDidMount() {
    this.loadData();
  }

  // =====================
  // LOAD DATA
  // =====================

  loadData = async () => {

    this.setState({ loading: true });

    try {

      const { page, pageSize, filter,searchParam } = this.state;

      const res = await this.props.getExpenses(

        this.props.user.store.key,
        (page - 1) * pageSize,
        pageSize,
        filter.status,
        filter.party || searchParam,
        filter.fromDate,
        filter.toDate,
        filter.expenseCategory,
        filter.expenseNo,
        filter.referenceNo

      );

      let list = [];
      let totalCount = 0;

      console.log("204",res);
      if (res && res.hasOwnProperty("searchResult")) {
        list = res.searchResult;
      }

      if (res && res.hasOwnProperty("totalItemsCount")) {
        totalCount = res.totalItemsCount;
      }

      this.setState({
        list,
        totalCount,
        loading: false
      });

    }

    catch (error) {

      console.error(error);

      this.setState({
        loading: false
      });

    }

  };

  // =====================
  // SEARCH
  // =====================

  onSearch = (text) => {

    this.setState({
      searchParam: text,
      page: 1
    },
      this.loadData
    );

  };

  onRefreshClick = () => {

    this.setState({

      filter: {
        party: "",
        fromDate: "",
        toDate: "",
        expenseCategory: "",
        expenseNo: "",
        referenceNo: "",
        status: ""
      },

      page: 1,
      isFilterActive: false

    },

      this.loadData

    );

  };

  // =====================
  // FILTER CHANGE
  // =====================

  onFilterChange = (key, value) => {

    this.setState({

      filter: {
        ...this.state.filter,
        [key]: value
      }

    });

  };

  // =====================
  // PAGINATION
  // =====================

  onNextClick = () => {

    const totalPages = Math.ceil(
      this.state.totalCount / this.state.pageSize
    );

    if (this.state.page < totalPages) {

      this.setState({
        page: this.state.page + 1
      },
        this.loadData
      );

    }

  };

  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState({
        page: this.state.page - 1
      },
        this.loadData
      );

    }

  };

  onFirstClick = () => {

    this.setState({ page: 1 },
      this.loadData
    );

  };

  onLastClick = () => {

    const totalPages = Math.ceil(
      this.state.totalCount / this.state.pageSize
    );

    this.setState({
      page: totalPages
    },
      this.loadData
    );

  };

  onRecordsPerPageCountChange = (size) => {

    this.setState({
      pageSize: Number(size),
      page: 1
    },
      this.loadData
    );

  };

  // =====================
  // HEADER BUTTON
  // =====================

  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "new") {

      this.setState({
        showAddExpense: true,
        selectedRow: null
      });

    }

    if (btn.Action === "options") {

      this.setState({
        showOption: true
      });

    }

  };

  // =====================
  // FILTER
  // =====================

  onApplyFilter = () => {

    this.setState({

      page: 1,
      showFilter: false,
      isFilterActive: true

    },

      this.loadData

    );

  };

  onClearFilter = () => {

    this.onRefreshClick();

    this.setState({
      showFilter: false
    });

  };

  // =====================
  // ROW BUTTON
  // =====================

  onRowButtonClicked = (btn, row) => {

    if (btn.Type === "edit") {

      this.setState({
        showAddExpense: true,
        selectedRow: row
      });

    }

    if (btn.Type === "delete") {

      this.setState({
        showDelete: true,
        selectedRow: row
      });

    }

  };

  // =====================
  // DELETE
  // =====================

  deleteRecord = async () => {

    if (!this.state.cancellationReason) {

      this.setState({
        cancellationReasonError: "Cancellation reason required"
      });

      return;

    }

    this.setState({showDelete:false, loading: true});

    await this.props.cancelExpense(

      this.state.cancellationReason,
      this.state.selectedRow.key

    );

      await new Promise(resolve => setTimeout(resolve, 3000));
    this.setState({
        loading:false,
      selectedRow: null,
      cancellationReason: "",
      cancellationReasonError: ""

    },

     await this.loadData

    );

  };

  // =====================
  // EXPORT
  // =====================

  getExportData = async () => {

    const { filter,searchParam } = this.state;

    this.setState({ loading: true });

    const response = await this.props.getExpenses(
      this.props.user.store.key,
      0,
      10000,
      filter.status,
      filter.party || searchParam,
      filter.fromDate,
      filter.toDate,
      filter.expenseCategory,
      filter.expenseNo,
      filter.referenceNo

    );

    this.setState({ loading: false });

    return response.searchResult || [];

  };

  handleExport = async (type) => {

    this.setState({ loading: true });

    try {

      const data = await this.getExportData();

      if (!data.length) {

        alert("No data found");
        return;
      }

      const columns = [

        { header: "Expense No", field: "ExpenseNo" },
        { header: "Expense Date", field: "ExpenseDate", type: "date" },
        { header: "Party First Name", field: "Party.PartyFirstName" },
        { header: "Party Last Name", field: "Party.PartyLastName" },
        { header: "Expense Category", field: "ExpenseCategory" },
        { header: "RefNo", field: "RefNo" },
        { header: "Note", field: "Note" },
        { header: "Payment Type", field: "PaymentType" },
        { header: "PaymentRemark", field: "PaymentRemark" },
        { header: "Cash Register", field: "CashRegister" },
        { header: "Amount", field: "Amount" },
        { header: "Status", field: "Status" },
        { header: "Cancellation Reason", field: "CancellationReason" },
        { header: "Action", field: "Action" },
        { header: "Action On", field: "ActionOn", type: "date" },
        { header: "Action By Email ID", field: "ActionByEmailID" },

        { header: "Transaction No", field: "TransactionNo" },
        { header: "Transaction Date", field: "TransactionDate" },
        { header: "Bill Amount", field: "BillAmount" },
        { header: "Paid Amount", field: "PaidAmount" },
        { header: "Balance Amount", field: "BalanceAmountToBePaid" }

      ];

      await exportFile({

        data,
        columns,
        fileType: type,
        title: "Expense",
        landscape: true

      });

    }

    catch (error) {

      console.error(error);

      alert("Export failed");

    }

    finally {

      this.setState({ loading: false });

    }

  };

  // =====================
  // POPUP EVENTS
  // =====================

  onPostPopupSave = () => {

    this.setState({

      showAddExpense: false,
      selectedRow: null

    },

      this.loadData

    );

  };

  onClosePopup = () => {

    this.setState({

      showAddExpense: false,
      selectedRow: null

    });

  };

  onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};

  render() {

    const f = this.state.filter;

    return (

      <>

        <ListingPage

          {...this.props}
           onPageChange={this.onPageChange}

          listPageSettings={{

            ...this.state.listPageSettings,

            Search: {

              ...this.state.listPageSettings.Search,

              isFilterActive: this.state.isFilterActive

            }

          }}

          list={this.state.list}

          loading={this.state.loading}

          totalItemsCount={this.state.totalCount}

          recordFrom={(this.state.page - 1) * this.state.pageSize}

          itemsCountPerPage={this.state.pageSize}

          onNextClick={this.onNextClick}

          onPreviousClick={this.onPreviousClick}

          onFirstClick={this.onFirstClick}

          onLastClick={this.onLastClick}

          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}

          onHeaderButtonClicked={this.onHeaderButtonClicked}

          onRowButtonClicked={this.onRowButtonClicked}

        />

        {/* FILTER WINDOW */}

        {this.state.showFilter && (

          <Window

            header="Filter"

            size="small"

            slide

            onClose={() => this.setState({ showFilter: false })}

            onButtonClick={(action) => {

              if (action.toLowerCase() === "apply") {

                this.onApplyFilter();

              }

              else if (action.toLowerCase() === "clear") {

                this.onClearFilter();

              }

            }}

            buttons={[

              { Type: "secondary", Text: "Clear", Align: "left" },

              { Type: "primary", Text: "Apply", Align: "right" }

            ]}

          >

            <Input
              type="text"
              label="Party"
              value={f.party}
              onChange={(v) => this.onFilterChange("party", v)}
            />

            <Input
              type="date"
              label="From Date"
              value={f.fromDate}
              onChange={(v) => this.onFilterChange("fromDate", v)}
            />

            <Input
              type="date"
              label="To Date"
              value={f.toDate}
              onChange={(v) => this.onFilterChange("toDate", v)}
            />

            <Input
              type="text"
              label="Expense Category"
              value={f.expenseCategory}
              onChange={(v) => this.onFilterChange("expenseCategory", v)}
            />

            <Input
              type="text"
              label="Expense No"
              value={f.expenseNo}
              onChange={(v) => this.onFilterChange("expenseNo", v)}
            />

            <Input
              type="text"
              label="Reference Number"
              value={f.referenceNo}
              onChange={(v) => this.onFilterChange("referenceNo", v)}
            />

            <Input
              type="select"
              label="Status"
              value={f.status}
              onChange={(v) => this.onFilterChange("status", v)}
            >

                 <option value="">All</option>
          <option value="pending">Pending</option>
          <option value="paid">Paid</option>
          <option value="cancelled">Cancelled</option>

            </Input>

          </Window>

        )}

        {/* OPTIONS WINDOW */}

        {this.state.showOption && (

          <Window

            header="Options" choiceList

            size="small"

            slide

            onClose={() => this.setState({ showOption: false })}

          >

            <div

              style={{

                display: "flex",
                flexDirection: "row",
                gap: 10,
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap"

              }}

            >

              <ExportButton

                onExport={this.handleExport}

                loading={this.state.loading}

              />

            </div>

          </Window>

        )}

        {/* DELETE WINDOW */}

        {this.state.showDelete && (

          <Window

            header="Cancellation Reason"

            modal

            onClose={() => this.setState({ showDelete: false })}

            onButtonClick={(btn) => {

              if (btn === "Yes")

                this.deleteRecord();

              else

                this.setState({ showDelete: false });

            }}

            buttons={[

              { Type: "secondary", Text: "No", Align: "left" },

              { Type: "primary", Text: "Yes", Align: "right" }

            ]}

          >

            <Input

              type="textarea"

              label="Enter Reason"

              value={this.state.cancellationReason}

              error={this.state.cancellationReasonError}

              onChange={(v) =>

                this.setState({

                  cancellationReason: v,

                  cancellationReasonError: ""

                })

              }

            />

          </Window>

        )}

        {/* ADD / EDIT */}

        {this.state.showAddExpense && (

          <Expense

            {...this.props}

            expense={this.state.selectedRow}

            onSave={this.onPostPopupSave}

            onClose={this.onClosePopup}

          />

        )}

      </>

    );

  }

}

export default ExpenseList;